import React from 'react';
import { Input, InputProps } from 'antd';
import classNames from 'classnames';

import { ReactComponent as SearchIcon } from 'shared/assets/icons/search.svg';

import styles from './SearchInput.module.scss';

// TODO: Replace the search everywhere

export const SearchInput: React.FC<Omit<InputProps, 'prefix'>> = ({ className, ...props }) => {
  return (
    <Input
      prefix={<SearchIcon className={styles.searchIcon} />}
      className={classNames(styles.searchInput, className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};
